import { type Question, type Survey } from 'types/surveys';

type SurveyWithQuestions = Survey & { questions?: Question[] };

export const getSurveyQuestions = (survey: Survey | undefined): Question[] | undefined =>
  survey && 'questions' in survey ? (survey as SurveyWithQuestions).questions : undefined;
